// extracted by mini-css-extract-plugin
export default {"btn":"ButtonReturn_btn__jDJR8"};